import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Button, Dialog, Grid, List, ListItem, ListItemText, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import ListaRegraValidacao from 'esocial.web.react.lib/cjs/components/form/Validation/ListaRegraValidacao';
import RegraCpf from 'esocial.web.react.lib/cjs/components/form/Validation/RegraCpf';
import RegraObrigatoriedade from 'esocial.web.react.lib/cjs/components/form/Validation/RegraObrigatoriedade';
import { VepSelect } from 'esocial.web.react.lib/cjs/components/form/Vep/VepSelect';
import { VepTextField } from 'esocial.web.react.lib/cjs/components/form/Vep/VepTextField';
import { CustomDialogActions, CustomDialogContent, CustomDialogTitle } from 'esocial.web.react.lib/cjs/components/util/Dialog';
import { Display } from 'esocial.web.react.lib/cjs/components/util/Display';
import { Fieldset } from 'esocial.web.react.lib/cjs/components/util/Fieldset';
import { CustomTable } from 'esocial.web.react.lib/cjs/components/util/Table';
import { useAppDispatch } from 'esocial.web.react.lib/cjs/hooks/Reduz';
import { abrirModalConfirmacao, fecharModalConfirmacao } from "esocial.web.react.lib/cjs/store/reducers/modais";
import { Mascara } from 'esocial.web.react.lib/cjs/utils/enums';
import { calcularHashDeString, getStringValue, isUndefinedOrNull, obterObjetoTodosComponentesIntocados, obterObjetoTodosComponentesTocados, retornarFocoParaBotaoChamador, rolarVisualizacaoAteElementoInvalido, verificarTodosComponentesTocados } from 'esocial.web.react.lib/cjs/utils/geral';
import { Fragment, useEffect, useRef, useState } from 'react';
import VMasker from 'vanilla-masker';

const ButtonTextPrimary = styled(IconButton)(({ theme }) => ({
    color: theme.palette.text.primary,
}));

const ContainerBotoesTabelaAcao = styled(TableCell)(({ theme }) => ({
    '& > *': {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
}));

function calcularHashItem(item) {
    return calcularHashDeString(`${item.cpfResponsavel}${item.orgaoClasse}${item.numeroInscricaoOrgaoClasse}${item.ufOrgaoClasse}`);
}

const chaveNovoItem = 'n';
const sufixoChaveExcluirItem = '_e';

function ResponsaveisRegistro(props) {
    // Trecho reservado para ajuste no retorno da modal de inserir/editar item
    const action = useRef(null);
    const ref = useRef(null);

    const [chaveActionRefAtual, setChaveActionRefAtual] = useState(null);
    // Fim de Trecho reservado para ajuste no retorno da modal de inserir/editar item

    const [habilitarEdicaoAtualizacao, setHabilitarEdicaoAtualizacao] = useState(false);
    const [habilitarInsercaoAtualizacao, setHabilitarInsercaoAtualizacao] = useState(false);
    const [habilitarVisualizacao, setHabilitarVisualizacao] = useState(false);
    const [codigoAgenteNocivoDiferenteDe_09_01_001, setCodigoAgenteNocivoDiferenteDe_09_01_001] = useState(false);

    const dispatch = useAppDispatch();

    function excluirItem(indice, hashExclusao) {
        const modalConfirmacaoProps = {
            texto: 'Tem certeza que deseja excluir "Responsável pelo Registro Ambiental"?',
            textoBotaoNao: 'Não',
            textoBotaoSim: 'Sim',
            actionBotaoNao: () => {
                setChaveActionRefAtual(hashExclusao);
                retornarFocoParaBotaoChamador(action, ref);
                dispatch(fecharModalConfirmacao());
            },
            actionBotaoSim: async () => {
                props.setModelo({
                    ...props.modelo, listaResponsaveisRegistro: props.modelo.listaResponsaveisRegistro.filter((l) => l !== props.modelo.listaResponsaveisRegistro[indice])
                });

                // Ao excluir um item, retornar o foco ao botão de inclusão de novo item
                setChaveActionRefAtual(chaveNovoItem);
                retornarFocoParaBotaoChamador(action, ref);
            }
        };

        dispatch(abrirModalConfirmacao(modalConfirmacaoProps));
    }

    // Estado de campos ainda não tocados pelo usuário e formulário ainda não submetido (usado no mecanismo de validações)
    const objetoComponentesTocados = {};

    objetoComponentesTocados['itemResponsavelRegistroAuxiliar.cpfResponsavel'] = false;
    objetoComponentesTocados['itemResponsavelRegistroAuxiliar.orgaoClasse'] = false;
    objetoComponentesTocados['itemResponsavelRegistroAuxiliar.numeroInscricaoOrgaoClasse'] = false;
    objetoComponentesTocados['itemResponsavelRegistroAuxiliar.ufOrgaoClasse'] = false;
    objetoComponentesTocados['itemResponsavelRegistroAuxiliar.descricaoOrgaoClasse'] = false;

    const [componenteTocadoFormulario, setComponenteTocadoFormulario] = useState(objetoComponentesTocados);

    // Construção das regras de validação para os campos do formulário
    const [regraValidacaoFormulario, setRegraValidacaoFormulario] = useState({});

    useEffect(() => {
        const objetoRegrasValidacao = {};

        // Regra de obrigatoriedade de alguns campos depende de não haver entre os agentes nocivos cadastrados algum cujo código seja 09.01.001
        setCodigoAgenteNocivoDiferenteDe_09_01_001(props.modelo.listaAgentesNocivos.filter((x) => x.codigo === '09.01.001').length === 0);

        if (props.modelo != null) {
            objetoRegrasValidacao['itemResponsavelRegistroAuxiliar.cpfResponsavel'] = new ListaRegraValidacao([new RegraObrigatoriedade(props.modelo.itemResponsavelRegistroAuxiliar.cpfResponsavel.valor), new RegraCpf(props.modelo.itemResponsavelRegistroAuxiliar.cpfResponsavel.valor)], componenteTocadoFormulario['itemResponsavelRegistroAuxiliar.cpfResponsavel']);
            objetoRegrasValidacao['itemResponsavelRegistroAuxiliar.orgaoClasse'] = new RegraObrigatoriedade(props.modelo.itemResponsavelRegistroAuxiliar.orgaoClasse.valor, componenteTocadoFormulario['itemResponsavelRegistroAuxiliar.orgaoClasse'] && codigoAgenteNocivoDiferenteDe_09_01_001);
            objetoRegrasValidacao['itemResponsavelRegistroAuxiliar.numeroInscricaoOrgaoClasse'] = new RegraObrigatoriedade(props.modelo.itemResponsavelRegistroAuxiliar.numeroInscricaoOrgaoClasse.valor, componenteTocadoFormulario['itemResponsavelRegistroAuxiliar.numeroInscricaoOrgaoClasse'] && codigoAgenteNocivoDiferenteDe_09_01_001);
            objetoRegrasValidacao['itemResponsavelRegistroAuxiliar.ufOrgaoClasse'] = new RegraObrigatoriedade(props.modelo.itemResponsavelRegistroAuxiliar.ufOrgaoClasse.valor, componenteTocadoFormulario['itemResponsavelRegistroAuxiliar.ufOrgaoClasse'] && codigoAgenteNocivoDiferenteDe_09_01_001);
            objetoRegrasValidacao['itemResponsavelRegistroAuxiliar.descricaoOrgaoClasse'] = new RegraObrigatoriedade(props.modelo.itemResponsavelRegistroAuxiliar.descricaoOrgaoClasse.valor, componenteTocadoFormulario['itemResponsavelRegistroAuxiliar.descricaoOrgaoClasse'] && getStringValue(props.modelo.itemResponsavelRegistroAuxiliar.orgaoClasse.valor) === '9');
            objetoRegrasValidacao.todosComponentesTocados = verificarTodosComponentesTocados(componenteTocadoFormulario);
        }

        setRegraValidacaoFormulario(objetoRegrasValidacao);
    }, [props.modelo, componenteTocadoFormulario]);

    const [nomeFuncaoAcaoFormularioCompletamenteValidado, setNomeFuncaoAcaoFormularioCompletamenteValidado] = useState(null);

    useEffect(() => {
        const valoresValidacaoFormulario = Object.values(regraValidacaoFormulario).filter((x) => typeof x !== 'boolean');

        if (regraValidacaoFormulario.todosComponentesTocados) {
            if (typeof nomeFuncaoAcaoFormularioCompletamenteValidado === 'string' && valoresValidacaoFormulario.length > 0) {
                if (!new ListaRegraValidacao(valoresValidacaoFormulario).existeErro()) {
                    if (nomeFuncaoAcaoFormularioCompletamenteValidado === 'inserirItem') {
                        inserirItem();
                    }
                    else if (nomeFuncaoAcaoFormularioCompletamenteValidado === 'editarItem') {
                        editarItem();
                    }

                    retornarFocoParaBotaoChamador(action, ref);
                }
                else {
                    rolarVisualizacaoAteElementoInvalido('modalResponsaveisRegistro');
                }
            }

            setNomeFuncaoAcaoFormularioCompletamenteValidado(null);
        }

    }, [nomeFuncaoAcaoFormularioCompletamenteValidado, regraValidacaoFormulario.todosComponentesTocados]);

    const habilitarEdicaoItem = () => {
        setHabilitarEdicaoAtualizacao(true);
    };

    const habilitarVisualizacaoItem = () => {
        setHabilitarVisualizacao(true);
    };

    function cancelar() {
        setHabilitarEdicaoAtualizacao(false);
        setHabilitarInsercaoAtualizacao(false);
        setHabilitarVisualizacao(false);

        // Limpar os valores dos campos auxiliares
        props.setModelo({
            ...props.modelo,
            itemResponsavelRegistroAuxiliar: {
                cpfResponsavel: { ...props.modelo.itemResponsavelRegistroAuxiliar.cpfResponsavel, valor: null },
                orgaoClasse: { ...props.modelo.itemResponsavelRegistroAuxiliar.orgaoClasse, valor: null },
                descricaoOrgaoClasse: { ...props.modelo.itemResponsavelRegistroAuxiliar.descricaoOrgaoClasse, valor: null },
                numeroInscricaoOrgaoClasse: { ...props.modelo.itemResponsavelRegistroAuxiliar.numeroInscricaoOrgaoClasse, valor: '' },
                ufOrgaoClasse: { ...props.modelo.itemResponsavelRegistroAuxiliar.ufOrgaoClasse, valor: '' }
            }
        });

        retornarFocoParaBotaoChamador(action, ref);
    }

    const novoItem = () => {
        setComponenteTocadoFormulario(obterObjetoTodosComponentesIntocados(componenteTocadoFormulario));
        setHabilitarInsercaoAtualizacao(true);
        setChaveActionRefAtual(chaveNovoItem);
    };

    function inserirItem() {
        const itemLista = {
            cpfResponsavel: props.modelo.itemResponsavelRegistroAuxiliar.cpfResponsavel.valor,
            orgaoClasse: isUndefinedOrNull(props.modelo.itemResponsavelRegistroAuxiliar.orgaoClasse.valor) ? 0 : props.modelo.itemResponsavelRegistroAuxiliar.orgaoClasse.valor,
            descricaoOrgaoClasse: props.modelo.itemResponsavelRegistroAuxiliar.descricaoOrgaoClasse.valor,
            numeroInscricaoOrgaoClasse: props.modelo.itemResponsavelRegistroAuxiliar.numeroInscricaoOrgaoClasse.valor,
            ufOrgaoClasse: props.modelo.itemResponsavelRegistroAuxiliar.ufOrgaoClasse.valor
        };

        props.setModelo({
            ...props.modelo, listaResponsaveisRegistro: [...props.modelo.listaResponsaveisRegistro, itemLista],
            itemResponsavelRegistroAuxiliar: {
                cpfResponsavel: { ...props.modelo.itemResponsavelRegistroAuxiliar.cpfResponsavel, valor: null },
                orgaoClasse: { ...props.modelo.itemResponsavelRegistroAuxiliar.orgaoClasse, valor: null },
                descricaoOrgaoClasse: { ...props.modelo.itemResponsavelRegistroAuxiliar.descricaoOrgaoClasse, valor: null },
                numeroInscricaoOrgaoClasse: { ...props.modelo.itemResponsavelRegistroAuxiliar.numeroInscricaoOrgaoClasse, valor: '' },
                ufOrgaoClasse: { ...props.modelo.itemResponsavelRegistroAuxiliar.ufOrgaoClasse, valor: '' }
            }
        });

        setHabilitarInsercaoAtualizacao(false);
    }

    function copiarItem(indice, somenteLeitura, hash) {
        if (somenteLeitura) {
            habilitarVisualizacaoItem();
        } else {
            habilitarEdicaoItem();
        }

        props.setModelo({
            ...props.modelo,
            itemResponsavelRegistroAuxiliar: {
                chave: indice,
                cpfResponsavel: { ...props.modelo.itemResponsavelRegistroAuxiliar.cpfResponsavel, valor: props.modelo.listaResponsaveisRegistro[indice].cpfResponsavel },
                orgaoClasse: { ...props.modelo.itemResponsavelRegistroAuxiliar.orgaoClasse, valor: props.modelo.listaResponsaveisRegistro[indice].orgaoClasse },
                descricaoOrgaoClasse: { ...props.modelo.itemResponsavelRegistroAuxiliar.descricaoOrgaoClasse, valor: props.modelo.listaResponsaveisRegistro[indice].descricaoOrgaoClasse },
                numeroInscricaoOrgaoClasse: { ...props.modelo.itemResponsavelRegistroAuxiliar.numeroInscricaoOrgaoClasse, valor: props.modelo.listaResponsaveisRegistro[indice].numeroInscricaoOrgaoClasse },
                ufOrgaoClasse: { ...props.modelo.itemResponsavelRegistroAuxiliar.ufOrgaoClasse, valor: props.modelo.listaResponsaveisRegistro[indice].ufOrgaoClasse }
            }
        });

        setChaveActionRefAtual(hash);
    }

    function editarItem() {
        const itemLista = {
            cpfResponsavel: props.modelo.itemResponsavelRegistroAuxiliar.cpfResponsavel.valor,
            orgaoClasse: isUndefinedOrNull(props.modelo.itemResponsavelRegistroAuxiliar.orgaoClasse.valor) ? 0 : props.modelo.itemResponsavelRegistroAuxiliar.orgaoClasse.valor,
            descricaoOrgaoClasse: props.modelo.itemResponsavelRegistroAuxiliar.descricaoOrgaoClasse.valor,
            numeroInscricaoOrgaoClasse: props.modelo.itemResponsavelRegistroAuxiliar.numeroInscricaoOrgaoClasse.valor,
            ufOrgaoClasse: props.modelo.itemResponsavelRegistroAuxiliar.ufOrgaoClasse.valor
        };

        // Nesse ponto sabemos que o item pôde ser editado e chave para localização do botão com action e ref
        // de destino do foco deve ser recalculado em termos dos componentes do item
        const hash = calcularHashItem(itemLista);
        setChaveActionRefAtual(hash);

        let chaveAlteracao = props.modelo.itemResponsavelRegistroAuxiliar.chave;

        props.setModelo({
            ...props.modelo, listaResponsaveisRegistro: [...props.modelo.listaResponsaveisRegistro.filter((l) => l !== props.modelo.listaResponsaveisRegistro[chaveAlteracao]), itemLista],
            itemResponsavelRegistroAuxiliar: {
                cpfResponsavel: { ...props.modelo.itemResponsavelRegistroAuxiliar.cpfResponsavel, valor: null },
                orgaoClasse: { ...props.modelo.itemResponsavelRegistroAuxiliar.orgaoClasse, valor: null },
                descricaoOrgaoClasse: { ...props.modelo.itemResponsavelRegistroAuxiliar.descricaoOrgaoClasse, valor: null },
                numeroInscricaoOrgaoClasse: { ...props.modelo.itemResponsavelRegistroAuxiliar.numeroInscricaoOrgaoClasse, valor: '' },
                ufOrgaoClasse: { ...props.modelo.itemResponsavelRegistroAuxiliar.ufOrgaoClasse, valor: '' }
            }
        });

        setHabilitarEdicaoAtualizacao(false);
    }

    function atualizarItem() {
        setComponenteTocadoFormulario(obterObjetoTodosComponentesTocados(componenteTocadoFormulario));
        setNomeFuncaoAcaoFormularioCompletamenteValidado(habilitarEdicaoAtualizacao ? 'editarItem' : 'inserirItem');
    }

    return (
        (props.modelo !== null && Object.values(regraValidacaoFormulario).length > 0) &&
        <Fragment>
            <Fieldset legend="Responsáveis pelo Registro Ambiental" spacing={4}>
                <Display show={!props.somenteVisualizacao}>
                    <Grid item style={{ flexBasis: '100%', paddingTop: '0.3rem' }}>
                        <Button color="primary"
                            startIcon={<AddIcon />}
                            onClick={() => novoItem()}
                            disabled={habilitarInsercaoAtualizacao || habilitarEdicaoAtualizacao}
                            action={chaveActionRefAtual === chaveNovoItem ? action : undefined}
                            ref={chaveActionRefAtual === chaveNovoItem ? ref : undefined}
                        >
                            Incluir Responsável pelo Registro Ambiental
                        </Button>
                    </Grid>
                </Display>

                <Display show={props.modelo.listaResponsaveisRegistro.length > 0}>
                    <Grid item style={{ flexBasis: '100%' }}>
                        <CustomTable>
                            <TableHead>
                                <TableRow>
                                    <TableCell align="center">CPF Responsável</TableCell>
                                    <TableCell align="center">Ação</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {props.modelo.listaResponsaveisRegistro.map((linha, indice) => {
                                    const hash = calcularHashItem(linha);
                                    const hashExclusao = `${hash}${sufixoChaveExcluirItem}`;

                                    return (
                                        <TableRow key={indice}>
                                            <TableCell align="center">{VMasker.toPattern(linha.cpfResponsavel, Mascara.CPF)}</TableCell>
                                            <ContainerBotoesTabelaAcao align="center">
                                                <Display show={props.somenteVisualizacao}>
                                                    <ButtonTextPrimary
                                                        color="inherit"
                                                        size="small"
                                                        aria-label="visualizar item"
                                                        onClick={() => copiarItem(indice, true, hash)}
                                                        action={chaveActionRefAtual === hash ? action : undefined}
                                                        ref={chaveActionRefAtual === hash ? ref : undefined}
                                                    >
                                                        <VisibilityIcon fontSize="small" />
                                                    </ButtonTextPrimary>
                                                </Display>
                                                <Display show={!props.somenteVisualizacao}>
                                                    <ButtonTextPrimary
                                                        color="inherit"
                                                        size="small"
                                                        aria-label="editar item"
                                                        onClick={() => copiarItem(indice, false, hash)}
                                                        disabled={habilitarInsercaoAtualizacao || habilitarEdicaoAtualizacao}
                                                        action={chaveActionRefAtual === hash ? action : undefined}
                                                        ref={chaveActionRefAtual === hash ? ref : undefined}
                                                    >
                                                        <EditIcon fontSize="small" />
                                                    </ButtonTextPrimary>
                                                    <IconButton
                                                        color="inherit"
                                                        size="small"
                                                        aria-label="excluir item"
                                                        onClick={() => excluirItem(indice, hashExclusao)}
                                                        disabled={habilitarInsercaoAtualizacao || habilitarEdicaoAtualizacao}
                                                        action={chaveActionRefAtual === hashExclusao ? action : undefined}
                                                        ref={chaveActionRefAtual === hashExclusao ? ref : undefined}
                                                    >
                                                        <DeleteIcon fontSize="small" />
                                                    </IconButton>
                                                </Display>
                                            </ContainerBotoesTabelaAcao>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </CustomTable>
                    </Grid>
                </Display>

                <Display show={props.modelo.listaResponsaveisRegistro.length < 1}>
                    <Grid item style={{ flexBasis: '100%' }}>
                        <Typography>Nenhum responsável pelo registro ambiental cadastrado</Typography>
                    </Grid>
                </Display>
            </Fieldset>

            {/*Modal para inserção/edição de responsável pelo registro ambiental*/}
            <Dialog
                open={(habilitarInsercaoAtualizacao || habilitarEdicaoAtualizacao) && !props.somenteVisualizacao}
                onClose={() => { cancelar() }}
                aria-labelledby="form-dialog-title"
                fullWidth
                maxWidth={false}
            >
                <CustomDialogTitle id="form-dialog-title">{habilitarInsercaoAtualizacao ? 'Incluir' : 'Editar'} Responsável pelo Registro Ambiental</CustomDialogTitle>
                <CustomDialogContent>
                    <Fieldset spacing={4}>
                        <VepTextField
                            accessor="itemResponsavelRegistroAuxiliar.cpfResponsavel"
                            label="Qual o CPF responsável pelos registros ambientais?"
                            model={props.modelo}
                            setModel={props.setModelo}
                            xs={12} md={5}
                            maskPattern={Mascara.CPF}
                            maxLength={14}
                            {...regraValidacaoFormulario['itemResponsavelRegistroAuxiliar.cpfResponsavel'].obterPropriedadesValidacao()}
                            onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'itemResponsavelRegistroAuxiliar.cpfResponsavel': true })}
                        />

                        <VepSelect
                            accessor="itemResponsavelRegistroAuxiliar.orgaoClasse"
                            label="Qual o órgão de classe ao qual o responsável pelos registros ambientais está vinculado?"
                            model={props.modelo}
                            setModel={props.setModelo}
                            xs={12} md={7}
                            required={codigoAgenteNocivoDiferenteDe_09_01_001}
                            {...regraValidacaoFormulario['itemResponsavelRegistroAuxiliar.orgaoClasse'].obterPropriedadesValidacao()}
                            onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'itemResponsavelRegistroAuxiliar.orgaoClasse': true })}
                        />

                        <Display show={props.modelo.itemResponsavelRegistroAuxiliar.orgaoClasse.valor == 9}>
                            <VepTextField
                                accessor="itemResponsavelRegistroAuxiliar.descricaoOrgaoClasse"
                                label="Descreva o Órgão de Classe"
                                model={props.modelo}
                                setModel={props.setModelo}
                                xs={12} md={5}
                                required
                                {...regraValidacaoFormulario['itemResponsavelRegistroAuxiliar.descricaoOrgaoClasse'].obterPropriedadesValidacao()}
                                onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'itemResponsavelRegistroAuxiliar.descricaoOrgaoClasse': true })}
                            />
                        </Display>

                        <VepTextField
                            accessor="itemResponsavelRegistroAuxiliar.numeroInscricaoOrgaoClasse"
                            label="Qual o número de inscrição do Órgão de Classe?"
                            model={props.modelo}
                            setModel={props.setModelo}
                            xs={12} md={5}
                            required={codigoAgenteNocivoDiferenteDe_09_01_001}
                            {...regraValidacaoFormulario['itemResponsavelRegistroAuxiliar.numeroInscricaoOrgaoClasse'].obterPropriedadesValidacao()}
                            onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'itemResponsavelRegistroAuxiliar.numeroInscricaoOrgaoClasse': true })}
                        />

                        {/*Inibido o atributo title pois o tooltip gerado está se sobrepondo às opções do select*/}
                        <VepSelect
                            accessor="itemResponsavelRegistroAuxiliar.ufOrgaoClasse"
                            label="Qual a UF?"
                            title=""
                            model={props.modelo}
                            setModel={props.setModelo}
                            xs={12} md={2}
                            required={codigoAgenteNocivoDiferenteDe_09_01_001}
                            {...regraValidacaoFormulario['itemResponsavelRegistroAuxiliar.ufOrgaoClasse'].obterPropriedadesValidacao()}
                            onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'itemResponsavelRegistroAuxiliar.ufOrgaoClasse': true })}
                        />
                    </Fieldset>
                </CustomDialogContent>
                <CustomDialogActions>
                    <Button variant="text" color="secondary" onClick={() => cancelar()}>
                        Cancelar
                    </Button>
                    <Button variant="text" color="primary" onClick={() => atualizarItem()}>
                        Salvar
                    </Button>
                </CustomDialogActions>
            </Dialog>

            {/*Modal para consulta de responsavel*/}
            <Dialog
                open={props.somenteVisualizacao && habilitarVisualizacao}
                onClose={() => { cancelar() }}
                aria-labelledby="modal-somente-visualizacao"
                fullWidth
                maxWidth={false}
                PaperProps={{ id: 'modalResponsaveisRegistro' }}
            >
                <CustomDialogTitle id="modal-somente-visualizacao">Visualizar Responsável pelo Registro Ambiental</CustomDialogTitle>
                <CustomDialogContent>
                    <div>
                        <List>
                            <Display show={props.modelo.itemResponsavelRegistroAuxiliar.cpfResponsavel != null && props.modelo.itemResponsavelRegistroAuxiliar.cpfResponsavel.valor != null}>
                                <ListItem>
                                    <ListItemText primary={props.modelo.itemResponsavelRegistroAuxiliar.cpfResponsavel.rotulo} secondary={props.modelo.itemResponsavelRegistroAuxiliar.cpfResponsavel.valor} />
                                </ListItem>
                            </Display>
                            <Display show={props.modelo.itemResponsavelRegistroAuxiliar.orgaoClasse != null && props.modelo.itemResponsavelRegistroAuxiliar.orgaoClasse.valor != null}>
                                <ListItem>
                                    <ListItemText primary={props.modelo.itemResponsavelRegistroAuxiliar.orgaoClasse.rotulo} secondary={props.modelo.itemResponsavelRegistroAuxiliar.orgaoClasse.fonteDados[props.modelo.itemResponsavelRegistroAuxiliar.orgaoClasse.valor]} />
                                </ListItem>
                            </Display>
                            <Display show={props.modelo.itemResponsavelRegistroAuxiliar.descricaoOrgaoClasse != null && props.modelo.itemResponsavelRegistroAuxiliar.descricaoOrgaoClasse.valor != null}>
                                <ListItem>
                                    <ListItemText primary={props.modelo.itemResponsavelRegistroAuxiliar.descricaoOrgaoClasse.rotulo} secondary={props.modelo.itemResponsavelRegistroAuxiliar.descricaoOrgaoClasse.valor} />
                                </ListItem>
                            </Display>
                            <Display show={props.modelo.itemResponsavelRegistroAuxiliar.numeroInscricaoOrgaoClasse != null && props.modelo.itemResponsavelRegistroAuxiliar.numeroInscricaoOrgaoClasse.valor != null}>
                                <ListItem>
                                    <ListItemText primary={props.modelo.itemResponsavelRegistroAuxiliar.numeroInscricaoOrgaoClasse.rotulo} secondary={props.modelo.itemResponsavelRegistroAuxiliar.numeroInscricaoOrgaoClasse.valor} />
                                </ListItem>
                            </Display>
                            <Display show={props.modelo.itemResponsavelRegistroAuxiliar.ufOrgaoClasse != null && props.modelo.itemResponsavelRegistroAuxiliar.ufOrgaoClasse.valor != null}>
                                <ListItem>
                                    <ListItemText primary={props.modelo.itemResponsavelRegistroAuxiliar.ufOrgaoClasse.rotulo} secondary={props.modelo.itemResponsavelRegistroAuxiliar.ufOrgaoClasse.fonteDados[props.modelo.itemResponsavelRegistroAuxiliar.ufOrgaoClasse.valor]} />
                                </ListItem>
                            </Display>
                        </List>
                    </div>
                </CustomDialogContent>
                <CustomDialogActions>
                    <Button variant="text" color="secondary" onClick={() => cancelar()}>
                        Voltar
                    </Button>
                </CustomDialogActions>
            </Dialog>
        </Fragment>
    );
}

export default ResponsaveisRegistro;
